import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

export interface ImageUploadToS3Response {
  message: string;
  link: string;
}

AxiosCurlirize(axios, () => {});

type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useImageUploadToS3API = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (file: File) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) ?? "";
        // The stored token already carries "Bearer " (set at login and on refresh). Adding it again sent
        // "Bearer Bearer …", which the server rejects with 401 and the axios interceptor turns into a logout.
        const authorization = accessToken.startsWith("Bearer ") ? accessToken : `Bearer ${accessToken}`;

        // Creating FormData to handle file uploads
        const formData = new FormData();
        formData.append("file", file);

        const response: InventoryTaxCreateAPIResponse = await axios
          .post(COUPON_SERVICE_APIS?.UPLOAD_IMAGE_TO_S3?.baseURL ?? "", formData, {
            headers: {
              Authorization: authorization,
              "Content-Type": "multipart/form-data", // Important for file uploads
            },
          })
          .then((res: AxiosResponse<ImageUploadToS3Response>) => {
            if (res.data) {
              toast.success("Image uploaded successfully");

              return { status: true, message: res.data.link };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]); // Send the cURL command to the logger

            captureError(e); // Custom error capturing
            return { status: false, message: null };
          });

        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch, configuration, captureError, sendCurl],
  );

  return { execute };
};
